import React from 'react';
import SEO from '../shared/components/SEO';

const BlogPage = () => {
  return (
    <>
      <SEO 
        title="Blog - BAGI Trans novosti i članci o građevinskoj mehanizaciji"
        description="Blog BAGI Trans - Najnovije vesti, saveti i članci o građevinskoj mehanizaciji, bagerima, utovarivačima i održavanju mašina. Stručni sadržaj za profesionalce."
        keywords="blog, novosti, članci, građevinska mehanizacija, bageri, utovarivači, održavanje mašina, BAGI Trans, stručni saveti"
        canonicalUrl="https://bagi.rs/blog"
        breadcrumbs={[
          { name: "Početna", url: "/" },
          { name: "Blog", url: "/blog" }
        ]}
        noindex={true}
      />
      <div className="about-us-page blog-page">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1>Blog</h1>
            <div className="line"></div>
            <div className="coming-soon-message mt-5">
              <h2>Coming Soon</h2>
              <p>We're working on creating amazing content for you. Stay tuned!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default BlogPage; 